
import AdNormSetsTab from './AdNormSetsTab'
import MainHeader from './MainHeader'
export default { 
  AdNormSetsTab,
  MainHeader
 }



// WEBPACK FOOTER //
// ./src/app/configuration/Template/config/components/generic/index.js